// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"60c8c61b","455":"46825070","977":"a2d0c7c8"}[chunkId] + ".chunk.js";
};